/**
 * Malaysian Postcode Lookup Utility
 * Uses accurate data from Malaysia Postcode CSV
 */

import postcodeData from '../data/postcodes.json';

/**
 * Get city and state by postcode
 * @param {string} postcode - 5-digit postcode
 * @returns {object|null} - { city, state } or null if not found
 */
export function getLocationByPostcode(postcode) {
  if (!postcode || postcode.length !== 5) {
    return null;
  }

  return postcodeData[postcode] || null;
}

/**
 * Validate postcode format
 * @param {string} postcode - Postcode to validate
 * @returns {boolean} - True if valid format
 */
export function isValidPostcode(postcode) {
  return /^\d{5}$/.test(postcode);
}

/**
 * Check if postcode exists in database
 * @param {string} postcode - Postcode to check
 * @returns {boolean} - True if exists
 */
export function postcodeExists(postcode) {
  return postcodeData.hasOwnProperty(postcode);
}
